module.exports = __webpack_public_path__ + "static/rabbitblanketcomf-352edb09de75b7519cffadcb4c6e0999.jpeg";